'use client'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'

import ProjectFunnelItem from '@/components/ProjectFunnel/ProjectFunnelItem'
import useCustomDevice from '@/hooks/useCustomDevice'

import '@fontsource/space-grotesk'

const items = [
    {
        title: 'Certification Check',
        description:
            'Projects are verified and certified by standards like Verra or Gold Standard, with extra scrutiny for innovative, uncertified methodologies.',
        image: '/images/projects-funnel/funnel-1.png',
    },
    {
        title: 'Documentation Review',
        description:
            'Reviewing project documentation, monitoring reports, and verification reports.',
        image: '/images/projects-funnel/funnel-2.png',
    },
    {
        title: 'Desk Research',
        description:
            'Analysing the latest scientific research about methodology, reviewing similar projects, news, local government sentiment and more.',
        image: '/images/projects-funnel/funnel-3.png',
    },
    {
        title: 'Developer Engagement',
        description:
            'Engaging directly with developers to understand their approach and how they mitigate risks.',
        image: '/images/projects-funnel/funnel-4.png',
    },
    {
        title: 'Third-Party Evaluation Comparison',
        description:
            'Cross-validation with independent ratings from entities like BeZero and CarbonPlan.',
        image: '/images/projects-funnel/funnel-5.png',
    },
    {
        title: 'Alignment with Oxford Offsetting Principles',
        description:
            'Ensuring project selection is science-backed, especially for innovative carbon removal projects.',
        image: '/images/projects-funnel/funnel-6.png',
    },
]

export const funnelBreakpointBumps = {
    lg: 300,
    md: 200,
    sm: 0,
}

const ProjectFunnel = () => {
    const { mdScreen, smScreen, xsScreen } = useCustomDevice(funnelBreakpointBumps)

    return (
        <Box>
            <Text
                variant={mdScreen ? 'h5' : 'h4'}
                sx={{ mb: 9, textAlign: smScreen ? `start` : `center`, minHeight: `58px` }}
            >
                Out of the hundreds we vet, {!smScreen && <br />} only the top 10–20% of climate
                projects make the cut
            </Text>
            <Box
                sx={{
                    width: `100%`,
                    fontFamily: `Space Grotesk`,
                    ...(!mdScreen && {
                        display: `flex`,
                        justifyContent: `center`,
                        gap: 3,
                    }),
                    ...(mdScreen && {
                        display: `grid`,
                        gridTemplateColumns: `repeat(3, auto)`,
                        justifyContent: `space-between`,
                        rowGap: 9,
                        columnGap: 2,
                    }),
                    ...(smScreen && {
                        display: `grid`,
                        gridTemplateColumns: `repeat(2, auto)`,
                        justifyContent: `center`,
                        rowGap: 9,
                        columnGap: 1,
                    }),
                    ...(xsScreen && {
                        display: `grid`,
                        gridTemplateColumns: `repeat(1, auto)`,
                        justifyContent: `start`,
                        rowGap: 0,
                        columnGap: 0,
                    }),
                }}
            >
                {items.map((item, index) => {
                    return (
                        <Box key={index}>
                            <ProjectFunnelItem {...item} index={index} />
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}

export default ProjectFunnel
